import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import LibroReclamacionesComponent from "../components/LibroReclamaciones/LibroReclamaciones";

export default function LibroReclamaciones() {
  return (
    <div>
      <Navbar />
      <LibroReclamacionesComponent />
      <Footer />
    </div>
  );
}
